export * from './IconAir';
export { default as IconAir } from './IconAir';
